import { updateMultipleElements } from '../actions/elementActions';
import { getElementId, getLabels } from '../../../common/elements/utils/elementPropertyUtils';
import { ImMNElement } from '../../../common/elements/elementModelTypes';
import { toArray } from '../../../common/utils/immutableHelper';
import { ELEMENT_UPDATE_TYPE } from '../../../common/elements/elementConstants';

export const addLabelToElements = (elements: Immutable.List<ImMNElement>, labelId: string, transactionId?: number) => {
    const updates = toArray(
        elements.map((element) => {
            const elementLabels = getLabels(element) || [];
            if (elementLabels.includes(labelId)) return null;

            return {
                id: getElementId(element),
                changes: {
                    labels: [...elementLabels, labelId],
                },
                meta: {
                    addedLabelIds: [labelId],
                },
            };
        }),
    )?.filter(Boolean);

    return updateMultipleElements({ transactionId, updates, updateType: ELEMENT_UPDATE_TYPE.LABEL });
};

export const removeLabelFromElements = (elements: Immutable.List<ImMNElement>, labelId: string) => {
    const updates = toArray(
        elements.map((element) => {
            const elementLabels = getLabels(element) || [];
            if (!elementLabels.includes(labelId)) return null;

            return {
                id: getElementId(element),
                changes: {
                    labels: elementLabels.filter((id: string) => id !== labelId),
                },
                meta: {
                    removedLabelIds: [labelId],
                },
            };
        }),
    )?.filter(Boolean);

    return updateMultipleElements({ updates, updateType: ELEMENT_UPDATE_TYPE.TOGGLE_LABEL });
};

export const replaceLabelOnElements = (
    elements: Immutable.List<ImMNElement>,
    oldLabelId: string,
    newLabelId: string,
) => {
    const updates = toArray(
        elements.map((element) => {
            const elementLabels = getLabels(element) || [];
            if (!elementLabels.includes(oldLabelId)) return null;

            return {
                id: getElementId(element),
                changes: {
                    labels: elementLabels.map((id: string) => (id === oldLabelId ? newLabelId : id)),
                },
            };
        }),
    )?.filter(Boolean);

    return updateMultipleElements({ updates });
};
